module.exports = require("/Users/vaaralav/Projects/vaaralav.com/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 588
// module chunks = 231608221292675